import React, { useState } from 'react';

import NewsletterCard from '@components/pages/NewsletterIndexLanding/NewsletterCard';
import { Newsletter } from '@utils/backend-api/newsletters';

interface NewsletterCardsProps {
  newsletters: Newsletter[];
}

const NewsletterCards = ({ newsletters }: NewsletterCardsProps) => {
  const [currentNewsletters, setCurrentNewsletters] = useState<Newsletter[]>(newsletters);

  const updateNewsletterSubscription = (id: number, subscribed: boolean) => {
    setCurrentNewsletters((prev) =>
      prev.map((nl) => (nl.id === id ? { ...nl, currentUserSubscribed: subscribed } : nl))
    );
  };

  return (
    <>
      {currentNewsletters.map((newsletter) => (
        <div key={newsletter.id} className="w-[299px] shrink-0 sm:w-auto">
          <NewsletterCard
            newsletter={newsletter}
            updateNewsletterSubscription={updateNewsletterSubscription}
          />
        </div>
      ))}
    </>
  );
};

export default NewsletterCards;
